/* eslint-disable no-unused-vars */
// import external dependencies
import 'jquery';

// Import everything from autoload
import './components/';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleProduct from './routes/product';


if (!window.routes) {
  /** Populate Router instance with DOM routes */
  const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
    // Product page
    singleProduct,
  });
  window.routes = routes;
}

/*$(document).ready(() => {
  routes.loadEvents();
});*/



// WEBPACK FOOTER //
// ./scripts/main.js